//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import Footer from '../components/footer.vue'
    import {
        SaunaKanbanQuery,
        MemberKanbanQuery
    } from '../../static/js/api.js'

    function loadtotal(that) {


        SaunaKanbanQuery({}, function (res) {
            console.log(res)
            if (res.data.IsSuccess) {

                that.data = JSON.parse(res.data.Result)
                var total = {
                    PreShiftLeft:0,
                    Comein:0,
                    Left:0,
                    UnCheckout:0,
                    UnCheckoutMoney:0,
                }
                var totalArr = that.data.GuestInfos
                for(let i of totalArr){
                    total.PreShiftLeft+=i.PreShiftLeft
                    total.Comein+=i.Comein
                    total.Left+=i.Left
                    total.UnCheckout+=i.UnCheckout
                    total.UnCheckoutMoney+=i.UnCheckoutMoney
                  
                }
                 total.PreShiftLeft=total.PreShiftLeft.toFixed(0)
                  total.Comein = total.Comein.toFixed(0)
                    total.Left = total.Left.toFixed(0)
                    total.UnCheckout = total.UnCheckout.toFixed(2)
                    total.UnCheckoutMoney = total.UnCheckoutMoney.toFixed(2)
                that.total =total



                MemberKanbanQuery({}, function (ress) {
                    console.log(ress)
                    if (ress.data.IsSuccess) {

                        that.data.PayDetails = JSON.parse(ress.data.Result).PayDetails
                        console.log(that.data)
                    } else {

                        that.$vux.toast.text('数据获取失败，请重试', 'middle')

                    }


                })



                that.loading=false

                console.log(that.data)
            } else {

                that.$vux.toast.text('数据获取失败，请重试', 'middle')

            }


        })

    }


    export default {
        name: 'app',
        components: {
            'pc-footer': Footer,
        },
        data() {
            return {
                loading:true,
                total:{},
                data: {
                    GuestFlows: {},
                    BarConsumeDetails: {},
                    BarConsumeSummary: {},
                    ConsumeDetails: {},
                    ConsumeSummary: {},
                    GuestPerConsume: {},
                    HandCardUsed: {},
                    MemberUsedDetail: {},
                    MemberUsedSummary: {},
                    NewMemberDetails: {},
                    NewMemberSummary: {},
                    PayModeDetails: {},
                    PayModeSummary: {
                        Money:1
                    },
                    PrepaidMemberDetails: {},
                    PrepaidMemberSummary: {},
                    PayDetails: {},

                },
                selected:1,
                selectedsr:1,
                msg: 'Welcome to Your Vue.js App',
                nav:[
                    {
                        id:1,
                        name:"人数统计"

                    },
                    {
                        id:2,
                        name:"收入情况"

                    },
                    {
                        id:3,
                        name:"销售类别"

                    },{
                        id:4,
                        name:"吧台统计"

                    }

                ],
                navsr:[
{
                        id:1,
                        name:"手牌统计"

                    }


                ]
            }
        },

        created() {
            var that = this
            loadtotal(that)


        },
        methods:{

            refresh(){
                this.loading=true
                var that=this
                loadtotal(that)


            },
            change(index){
                console.log(index)
                this.selected= parseInt(index+1)

            },

            changesr(index){
                console.log(index)
                this.selectedsr= parseInt(index+1)

            }


        }

    }



// WEBPACK FOOTER //
// ./src/pages/Block1.vue